import './PeriscopeSummary.scss';
import { appActions } from '@app';
import ErrorBoundary from 'antd/es/alert/ErrorBoundary';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { ApexClassScope, ApexTriggerScope, EmailAlertScope, EmailTemplateScope, EntityScope, FieldScope, FieldUpdateScope, FlowScope, PageLayoutScope, PardotAutomationRuleScope, PardotEmailScope, PardotEmailTemplateScope, PardotFieldScope, PardotFormScope, PardotLandingPageScope, PardotListScope, PardotObjectScope, PardotPageActionScope, PardotProfileScope, PicklistValueScope, ReportScope, TagScope, ValidationRuleScope, WorkflowRuleScope } from '@periscopes/scopes';
import { Else, If, Then } from 'react-if';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { PeriscopeHeader, PeriscopeTitle } from './general';
import React, { useEffect } from 'react';
import { useAction, usePeriscopeSummary } from '@hooks';
const periscopeComponentLookup = {
    [SonarObjectType.PardotAutomation]: PardotAutomationRuleScope,
    [SonarObjectType.PardotEmail]: PardotEmailScope,
    [SonarObjectType.PardotEmailTemplate]: PardotEmailTemplateScope,
    [SonarObjectType.PardotEntity]: PardotObjectScope,
    [SonarObjectType.PardotField]: PardotFieldScope,
    [SonarObjectType.PardotForm]: PardotFormScope,
    [SonarObjectType.PardotLandingPage]: PardotLandingPageScope,
    [SonarObjectType.PardotList]: PardotListScope,
    [SonarObjectType.PardotPageAction]: PardotPageActionScope,
    [SonarObjectType.PardotProfile]: PardotProfileScope,
    [SonarObjectType.SalesforceApexClass]: ApexClassScope,
    [SonarObjectType.SalesforceApexTrigger]: ApexTriggerScope,
    [SonarObjectType.SalesforceEmailTemplate]: EmailTemplateScope,
    [SonarObjectType.SalesforceEntity]: EntityScope,
    [SonarObjectType.SalesforceField]: FieldScope,
    [SonarObjectType.SalesforceFieldUpdate]: FieldUpdateScope,
    [SonarObjectType.SalesforceFlow]: FlowScope,
    [SonarObjectType.SalesforcePageLayout]: PageLayoutScope,
    [SonarObjectType.SalesforcePicklistValue]: PicklistValueScope,
    [SonarObjectType.SalesforceProfile]: null,
    [SonarObjectType.SalesforceProcessBuilder]: FlowScope,
    [SonarObjectType.SalesforceReport]: ReportScope,
    [SonarObjectType.SalesforceValidationRule]: ValidationRuleScope,
    [SonarObjectType.SalesforceWorkflowAlert]: EmailAlertScope,
    [SonarObjectType.SalesforceWorkflowRule]: WorkflowRuleScope,
    [SonarObjectType.SonarTag]: TagScope
};
export const PeriscopeSummary = ({ index, periscope }) => {
    const { headerLabel, id: sonarObjectId, type, subType } = periscope;
    const SummaryComponent = periscopeComponentLookup[type];
    const updatePeriscope = useAction(appActions.updatePeriscopeInfo);
    const { loading, summary } = usePeriscopeSummary(sonarObjectId, type);
    useEffect(() => {
        if (!periscope.name && summary) {
            updatePeriscope({
                name: summary.displayName,
                periscopeIndex: index
            });
        }
    }, [index, periscope.name, summary, updatePeriscope]);
    if (!SummaryComponent) {
        return null;
    }
    return (React.createElement(ErrorBoundary, null,
        React.createElement("div", { className: 'periscope-card', style: { zIndex: 100 - index } },
            React.createElement(PeriscopeHeader, { headerLabel: headerLabel, index: index, sonarObjectType: type, subType: subType, url: summary === null || summary === void 0 ? void 0 : summary.sourceUrl }),
            React.createElement("div", { className: 'periscope-content' },
                React.createElement(If, { condition: !loading && Boolean(summary) },
                    React.createElement(Then, null,
                        React.createElement(PeriscopeTitle, { data: summary }),
                        React.createElement(SummaryComponent, { data: summary, index: index })),
                    React.createElement(Else, null,
                        React.createElement(LoadingSpinner, null)))))));
};
